import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import CustomTable from "../../../ui/CustomTable";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../services/auth";
import ServicesCell from "./Render/ServicesCell";

function TableInfo({ client = [] }) {
  const navigate = useNavigate();
  let params = useParams();
  const { role } = useAuth();
  const id = params.id;

  const cols = [
    {
      label: "Site Name",
      name: "name",
      headTextLeft: true,
      textLeft: true,
    },
    {
      label: "Services",
      customRender: ServicesCell,
      multiRow: true,
    },
  ];

  const sites = client?.sites || [];

  return (
    <Box sx={{ mt: 2 }}>
      <CustomTable
        empty={sites?.length === 0 ? true : false}
        cols={cols}
        data={sites}
        showButton={false}
        isPagination={false}
      ></CustomTable>
    </Box>
  );
}

export default TableInfo;